import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ClientBottomNav from '../../components/ClientBottomNav.tsx';
import { baseurly } from '../../utils/apis.ts';
import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import '@cyntler/react-doc-viewer/dist/index.css';
import { X_API_KEY } from '../../utils/apis.ts';
import { baseurl } from '../../utils/apis.ts';

interface BuildProcess {
  id: number;
  name: string;
  description: string;
  file: string;
}

interface VehicleModel {
  id: number;
  model_name: string;
  vehicle_type: string;
  build_process?: BuildProcess;
}

const BuildProcessClientPage: React.FC = () => {
  const { vehicleId } = useParams();
  const [vehicleModel, setVehicleModel] = useState<VehicleModel | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (vehicleId) {
      fetch(`${baseurly}/vehicle_model/${vehicleId}`,{
              
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'X-API-KEY': X_API_KEY,
            },
            credentials: "include",
          })
        .then((res) => {
          if (!res.ok) {
            throw new Error('Failed to fetch vehicle model');
          }
          return res.json();
        })
        .then((data: VehicleModel) => {
          setVehicleModel(data);
          console.log(data);
          setLoading(false);
        })
        .catch((err) => {
          console.error('Error fetching vehicle model:', err);
          setError('Unable to load vehicle model');
          setLoading(false);
        });
    }
  }, [vehicleId]);

  // Construct file URL – if the file path is relative, prepend the base URL.
  const fileUrl =
    vehicleModel &&
    vehicleModel.build_process &&
    vehicleModel.build_process.file
      ? vehicleModel.build_process.file.startsWith('http')
        ? vehicleModel.build_process.file
        : `${baseurl}files/${vehicleModel.build_process.file}`
      : '';

  // Create docs array for react-doc-viewer.
  const docs = [
    {
      uri: fileUrl,
      fileType: "pdf",
    },
  ];

  if (loading) {
    return (
      <div className="min-h-screen bg-blue-900 p-6">
        <div className="text-white text-center mt-20">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-blue-900 p-6">
        <div className="text-white text-center mt-20">{error}</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-blue-900 pb-20 flex flex-col">
      {/* Page Title */}
      <div className="p-1">
        <h1 className="text-white text-lg font-medium">
          {vehicleModel?.build_process?.name || 'Build Process'}
        </h1>
      </div>

      {/* Build Process Content */}
      <div className="bg-white ring-2 ring-white-500 p-2 rounded-t-3xl flex-1 overflow-auto">
        {vehicleModel && vehicleModel.build_process && vehicleModel.build_process.file ? (
          <div className="w-full h-full">
            <DocViewer
              documents={docs}
              pluginRenderers={DocViewerRenderers}
              style={{ height: '100%', width: '100%' }}
            />
          </div>
        ) : (
          <div className="p-6 text-center text-gray-600">
            No build process found for this vehicle model.
          </div>
        )}
      </div>

      {/* Bottom Navigation */}
      {/* <ClientBottomNav showBack={true} /> */}
    </div>
  );
};

export default BuildProcessClientPage;
